export default function includeHelpId(props) {
    return props.help != null;
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/FormGroup/includeHelpId.ts